module.exports = __webpack_public_path__ + "src/app/_content/MOTFonts/BMWMotorradW01-Regular.woff?b553dee0f2165902c3fc0fa34b6f68ca";